import React from 'react';
import PropTypes from 'prop-types';
import {OutsourceListTable} from './OutsourceListTable';
import {OutsourceListMode} from './OutsourceListMode';
import {OutsourceListLegend} from './OutsourceListLegend';
import OutsourceListGrid from '../list/OutsourceListGrid';

export class OutsourceList extends React.Component {

    render() {
        const {
            data,
            mode,
            error,
            selectMode,
        } = this.props;

        if (error) {
            return (
                <section className={'error-section'}>
                    <h3 className={'text-center'}>{error}</h3>
                </section>
            );
        }

        return (
            <React.Fragment>
                <div className="row subcontrata-clave">
                    <div className="col-xs-8">
                        <OutsourceListLegend/>
                    </div>
                    <div className="col-xs-4">
                        <div className="grid-list pull-right">
                            <a id="list" onClick={() => {
                                selectMode(OutsourceListMode.LIST);
                            }}>
                                <i className="material-icons">list</i>
                            </a>
                            <a id="grid" onClick={() => {
                                selectMode(OutsourceListMode.GRID);
                            }}>
                                <i className="material-icons">view_module</i>
                            </a>
                        </div>
                    </div>
                </div>
                <hr></hr>
                {
                    mode === OutsourceListMode.GRID ?
                        <OutsourceListGrid outsources={data}/> :
                        <OutsourceListTable
                            data={data}
                            loading={false}
                            error={error}
                        />
                }
            </React.Fragment>
        );
    }
}

OutsourceList.propTypes = {
    data: PropTypes.array,
    mode: PropTypes.string,
    error: PropTypes.string,
    selectMode: PropTypes.func,
};

OutsourceList.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-outsources/outsource/list/OutsourceList.jsx